<template>
  <div class="create-outfit-placeholder">
    <div
      class="wrapper"
      :class="{ 'min-height': !outfitHasProducts, 'shrink-image': shrinkImage }"
    >
      <div class="wrapper-image" :class="{ 'shrink-image': shrinkImage }">
        <component :is="componentName" />
      </div>
      <div class="wrapper-plus">
        <span class="plus">+</span>
      </div>
    </div>
  </div>
</template>

<script>
// Icons
import IconAccessories1 from "@/components/capsuleBuilder/icons/IconAccessories1";
import IconAccessories2 from "@/components/capsuleBuilder/icons/IconAccessories2";
import IconBottoms from "@/components/capsuleBuilder/icons/IconBottoms";
import IconFootwear from "@/components/capsuleBuilder/icons/IconFootwear";
import IconInnerwear from "@/components/capsuleBuilder/icons/IconInnerwear";
import IconMidwear from "@/components/capsuleBuilder/icons/IconMidwear";
import IconOuterwear from "@/components/capsuleBuilder/icons/IconOuterwear";

import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    IconOuterwear,
    IconMidwear,
    IconInnerwear,
    IconBottoms,
    IconFootwear,
    IconAccessories1,
    IconAccessories2
  },

  mounted() {},

  data() {
    return {
      loadingData: true
    };
  },

  props: {
    slug: {
      type: String,
      required: true
    },

    outfitHasProducts: {
      type: Boolean,
      default: false
    },

    shrinkImage: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters([]),

    componentName() {
      return `Icon${this.layerName}`;
    },

    layerName() {
      return this.slug.replace(/^\w/, s => s.toUpperCase());
    },

    displayName() {
      return this.layerName.match(/[a-zA-Z]+|[0-9]+/g).join(" ");
    }
  },

  methods: {
    ...mapActions([""])
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";
@import "~@/styles/_breakpoints.scss";

.create-outfit-placeholder {
  cursor: pointer;
  border-top: 1px solid transparent;
  border-radius: 0.3em !important;
  height: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  * {
    transition: all 0.4s ease-in-out;
  }

  .wrapper {
    position: relative;
    display: inline-block;
    width: 100%;
    height: 100%;

    @include for-tablet-landscape-up {
      &.min-height {
        min-height: 121px;

        &.shrink-image {
          min-height: 90px;
        }
      }
    }

    .wrapper-plus {
      width: 100%;
      height: 100%;
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  &:hover {
    border-top: 1px solid $grey5;
    box-shadow: 0px 5px 5px 0px rgba(169, 169, 169, 1);

    .wrapper-image {
      opacity: 0;
    }

    .plus {
      opacity: 1;
    }
  }

  .wrapper-image {
    opacity: 1;
    position: absolute;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    @include for-tablet-portrait-up {
      &.shrink-image {
        svg.wardrobe {
          height: 80%;
        }
      }
    }

    svg.wardrobe {
      padding: 10px;
      fill: $grey4;

      @include for-tablet-landscape-up {
        padding: 0;
      }
    }
  }

  .plus {
    opacity: 0;
    color: #979c9c;
    border: none;
    font-size: 69px;
  }
}

.group-items {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin: 0 auto;
  justify-content: center;
}

.outfit-row {
  margin-bottom: 75px;
  width: 100%;

  .outfit-title {
    width: 100%;
    font-size: 20px;
    line-height: 32px;
    color: white;
    background: $primary-blue;
  }
}

.outfit-container {
  padding: 15px 30px;
  overflow: hidden;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  background: $grey8;
  border: 1px solid $grey5;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);

  .carousel-caption {
    bottom: -10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/wardrobe/CreateOutfitEmptyOuter.vue